// Productkaart (mb-card-product): kleurbolletjes met variantfoto en tooltip.
// - Muis (hover/pointer:fine): hover of toetsenbordfocus toont de variantfoto + tooltip, weg = terug, klik zet vast.
// - Touch: een tik zet de kleur vast (ring + variantfoto) en toont de tooltip ±1,5 s. Een tik navigeert niet.
// Dit is het enige script voor deze bolletjes; mbm-custom.js.liquid slaat .mb-pc-kleur over.
(function () {
  var muis = window.matchMedia('(hover: hover) and (pointer: fine)');
  var tipTimer = null;

  function kaartfoto(bolletje) {
    var kaart = bolletje.closest('[data-mb-kaart]');
    return kaart && kaart.querySelector('[data-mb-kaartfoto]');
  }

  function bewaarBasis(img) {
    img.dataset.mbOrigSrc = img.getAttribute('src');
    img.dataset.mbOrigSrcset = img.getAttribute('srcset') || '';
    img.dataset.mbOrigAlt = img.getAttribute('alt') || '';
  }

  function zet(img, bolletje) {
    img.srcset = bolletje.dataset.mbSrcset || '';
    img.src = bolletje.dataset.mbSrc;
    img.alt = bolletje.dataset.mbAlt || img.dataset.mbOrigAlt || img.alt;
  }

  function toon(bolletje) {
    var img = kaartfoto(bolletje);
    if (!img || !bolletje.dataset.mbSrc) return;
    if (!img.dataset.mbOrigSrc) bewaarBasis(img);
    img.dataset.mbDoel = bolletje.dataset.mbSrc;
    // Eerst op de achtergrond laden (zelfde srcset/sizes), dan pas wisselen: geen leeg vak of verspringen
    var voor = new Image();
    voor.sizes = img.getAttribute('sizes') || '';
    voor.srcset = bolletje.dataset.mbSrcset || '';
    voor.src = bolletje.dataset.mbSrc;
    var wissel = function () {
      if (img.dataset.mbDoel === bolletje.dataset.mbSrc) zet(img, bolletje);
    };
    (voor.decode ? voor.decode() : Promise.resolve()).then(wissel, wissel);
  }

  function terug(bolletje) {
    var img = kaartfoto(bolletje);
    if (!img || !img.dataset.mbOrigSrc) return;
    delete img.dataset.mbDoel;
    img.srcset = img.dataset.mbOrigSrcset;
    img.src = img.dataset.mbOrigSrc;
    img.alt = img.dataset.mbOrigAlt;
  }

  function kies(bolletje) {
    var lijst = bolletje.closest('ul');
    if (lijst) {
      lijst.querySelectorAll('.mb-pc-kleur.selected').forEach(function (b) { b.classList.remove('selected'); });
    }
    bolletje.classList.add('selected');
    var img = kaartfoto(bolletje);
    if (!img) return;
    delete img.dataset.mbDoel;
    if (bolletje.dataset.mbSrc) zet(img, bolletje);
    // De gekozen foto wordt de nieuwe basis, zodat mouseleave niet terugspringt
    bewaarBasis(img);
  }

  function tipKort(bolletje) {
    document.querySelectorAll('.mb-pc-kleur.is-tip').forEach(function (b) { b.classList.remove('is-tip'); });
    clearTimeout(tipTimer);
    bolletje.classList.add('is-tip');
    tipTimer = setTimeout(function () { bolletje.classList.remove('is-tip'); }, 1500);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.mb-pc-kleur');
    if (!b) return;
    e.preventDefault();
    kies(b);
    if (!muis.matches) tipKort(b);
  });

  document.addEventListener('mouseover', function (e) {
    if (!muis.matches) return;
    var b = e.target.closest && e.target.closest('.mb-pc-kleur');
    if (b && !b.contains(e.relatedTarget)) toon(b);
  });
  document.addEventListener('mouseout', function (e) {
    if (!muis.matches) return;
    var b = e.target.closest && e.target.closest('.mb-pc-kleur');
    if (b && !b.contains(e.relatedTarget)) terug(b);
  });
  document.addEventListener('focusin', function (e) {
    var b = e.target.closest && e.target.closest('.mb-pc-kleur');
    if (b && e.target.matches(':focus-visible')) toon(b);
  });
  document.addEventListener('focusout', function (e) {
    var b = e.target.closest && e.target.closest('.mb-pc-kleur');
    if (b) terug(b);
  });

  // Eén regel bolletjes + "+N": nooit afbreken. Max 5 (op mobiel kleinere bolletjes, zie mbm-custom.css.liquid);
  // past dat niet, dan minder bolletjes, maar de teller blijft altijd op de regel. Precies 5: alle, zonder teller.

  function pasIn(lijst) {
    var teller = lijst.querySelector('.mb-pc-kleur-meer');
    if (!teller) return;
    var bollen = Array.prototype.filter.call(lijst.children, function (li) { return li !== teller; });
    var totaal = parseInt(teller.dataset.mbTotaal, 10) || bollen.length;
    var max = Math.min(5, bollen.length);
    var zet = function (n) {
      bollen.forEach(function (li, i) { li.hidden = i >= n; });
      var rest = totaal - n;
      teller.hidden = rest < 1;
      var link = teller.querySelector('a');
      if (link.textContent !== '+' + rest) {
        link.textContent = '+' + rest;
        link.setAttribute('aria-label', 'Nog ' + rest + ' kleuren bekijken bij ' + (teller.dataset.mbTitel || ''));
      }
    };
    // Niet scrollWidth: de (onzichtbare) tooltips tellen daar mee. Meet tot de rand van het laatste zichtbare item.
    var tePlat = function () {
      var zichtbaar = Array.prototype.filter.call(lijst.children, function (li) { return !li.hidden; });
      var laatste = zichtbaar[zichtbaar.length - 1];
      return laatste && laatste.getBoundingClientRect().right > lijst.getBoundingClientRect().right + 0.5;
    };
    var n = totaal <= max ? totaal : max;
    zet(n);
    while (n > 1 && tePlat()) {
      n -= 1;
      zet(n);
    }
  }

  function allesInpassen() {
    document.querySelectorAll('.mb-pc-kleuren').forEach(pasIn);
  }

  var wacht = null;
  function straks() {
    cancelAnimationFrame(wacht);
    wacht = requestAnimationFrame(allesInpassen);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', allesInpassen);
  else allesInpassen();
  window.addEventListener('resize', straks);
  // Nieuwe kaarten (filteren, sorteren, volgende pagina) ook inpassen
  new MutationObserver(function (mutaties) {
    for (var i = 0; i < mutaties.length; i++) {
      var nieuw = mutaties[i].addedNodes;
      for (var j = 0; j < nieuw.length; j++) {
        var n = nieuw[j];
        if (n.nodeType === 1 && (n.matches('.mb-pc-kleuren') || n.querySelector('.mb-pc-kleuren'))) return straks();
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
